var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mk-banner-container"},[_c('img',{attrs:{"src":_vm.childItem.propsValue.data.customField1,"width":"100%","height":"100%"}}),(_vm.childItem.propsValue.data.customField2.text)?_c('a',{staticClass:"gotoFrom",attrs:{"href":"javascript:void(0);"}},[_vm._v(" "+_vm._s(_vm.childItem.propsValue.data.customField2.text)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }